import { render, staticRenderFns } from "./QiwiChoosePayment.vue?vue&type=template&id=4920fc9e&scoped=true&lang=true&"
import script from "./QiwiChoosePayment.vue?vue&type=script&lang=js&"
export * from "./QiwiChoosePayment.vue?vue&type=script&lang=js&"
import style0 from "./QiwiChoosePayment.vue?vue&type=style&index=0&id=4920fc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4920fc9e",
  null
  
)

export default component.exports